import _ from 'lodash';
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { Button, Modal, ModalBody, ModalFooter, Form, Input } from "@gpstrackit/react-controls";

import { NotificationManager } from "Components/Notifications";
import { createBillingAccount, updateBillingAccount, reset } from './redux/slice';

const CreateEditBillingAccount = (props) => {

    const { dealerId } = props;
    //Intl
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    //Redux states
    const { result, loading, billingAccount, openModal, error } = useSelector(state => state.createEditBillingAccountRedux)
    const [name, setName] = useState(billingAccount?.name || '');

    const closeModal = () => {
        dispatch(reset())
        setName('');
    }

    const handleSave = () => {
        const payload = {
            name: name,
            dealerId: dealerId
        };

        if (!billingAccount) {
            dispatch(createBillingAccount(payload));
        } else {
            payload.id = billingAccount.id;
            dispatch(updateBillingAccount(payload));
        }
    }

    useEffect(() => {
        if(openModal && billingAccount) {
            setName(billingAccount.name || '');
        }
    },[billingAccount])

    useEffect(() => {
        if (result) {
            let title = billingAccount ? messages['create_edit_billing_account_edit_title'] : messages['create_edit_billing_account_create_title']
            let successMessage = messages['create_edit_billing_account_successfully_save']
            let errorMessage = messages['create_edit_billing_account_error_save']

            if (!result?.error) {
                NotificationManager.success(successMessage, title, 3000);
                closeModal()
                props?.tableRef && props?.tableRef?.current?.getData();
            } else {
                if (error.includes('duplicated name'))
                    errorMessage = messages['create_edit_billing_account_error_repeated'];

                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }))
            }
        }
    }, [result])

    useEffect(() => {
        if (error) {
            let title = billingAccount ? messages['create_edit_billing_account_edit_title'] : messages['create_edit_billing_account_create_title']
            let errorMessage = messages['create_edit_billing_account_error_save']
            if (error.includes('duplicated name'))
                errorMessage = messages['create_edit_billing_account_error_repeated'];

            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }))
        }
    }, [error])

    return (
        <>
            <Modal
                open={openModal}
                title={`${billingAccount ? messages['create_edit_billing_account_edit_title'] : messages['create_edit_billing_account_create_title']}`}
                position="right"
                size="small"
                handleClose={closeModal}
                loading={loading}
            >
                <ModalBody>
                    <Form
                        ref={formRef}
                        onSubmit={() => {
                            return true
                        }}
                        onValidSubmit={() => {
                            handleSave();
                        }}
                    >
                        <div style={{ padding: '0 10px', marginBottom: 30 }}>
                            <div style={{ margin: 10 }}>
                                <Input
                                    type="text"
                                    label={messages['create_edit_billing_account_name']}
                                    placeholder={messages['create_edit_billing_account_name']}
                                    value={name}
                                    onChange={(value) => setName(value)}
                                    required
                                    requiredMessage={messages['required_field']}
                                    maxLength={50}
                                    minLength={3}
                                    minLengthMessage={`${messages['create_edit_billing_account_name_min_error']} 3`}
                                    maxLengthMessage={`${messages['create_edit_billing_account_name_max_error']} 50`}
                                />
                            </div>
                        </div>
                    </Form>
                </ModalBody>
                <ModalFooter>
                    <Button
                        className="btn btn-cancel"
                        onClick={() => closeModal()}
                    >
                        {messages['common_cancel']}
                    </Button>
                    <Button
                        className="btn-dark-blue"
                        onClick={() => {

                            formRef?.current?.submit();

                        }}
                    >
                        {messages['save']}
                    </Button>
                </ModalFooter>
            </Modal>

        </>
    )
}

export default CreateEditBillingAccount;